import { render, staticRenderFns } from "./TableUsedItemReminder.vue?vue&type=template&id=307ca33a"
import script from "./TableUsedItemReminder.vue?vue&type=script&lang=js"
export * from "./TableUsedItemReminder.vue?vue&type=script&lang=js"
import style0 from "./TableUsedItemReminder.vue?vue&type=style&index=0&id=307ca33a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports